import { Injectable, signal } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class CtaButtonSignalService {
  private _buttonDisabled = signal<any[]>([]);
  private _buttonHide = signal<any[]>([]);
  private _buttonLoading = signal<any[]>([]);
  public buttonDisabled = this._buttonDisabled;
  public buttonLoading = this._buttonLoading;
  public buttonHide = this._buttonHide;

  setSignal(newValue: { [key: string]: boolean }): void {
    /* false = disabled, true = enabled
    e.g. this.ctaButtonSignalService.setSignal({ [ButtonActionType.EXCHANGE_RE_QUOTE]: false }); */

    const index = this._buttonDisabled().findIndex((button) => Object.keys(newValue)[0] in button);
    if (index > -1) {
      this._buttonDisabled().splice(index, 1);
    }
    this._buttonDisabled.update((val) => [...val, newValue]);
  }

  setHideButtonSignal(newValue: { [key: string]: boolean }): void {
    const index = this._buttonHide().findIndex((button) => Object.keys(newValue)[0] in button);
    if (index > -1) {
      this._buttonHide().splice(index, 1);
    }
    this._buttonHide.update((val) => [...val, newValue]);
  }

  setButtonLoadingSignal(newValue: { [key: string]: boolean }): void {
    const index = this._buttonLoading().findIndex((button) => Object.keys(newValue)[0] in button);
    if (index > -1) {
      this._buttonLoading().splice(index, 1);
    }
    this._buttonLoading.update((val) => [...val, newValue]);
  }
}
